<script setup></script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="177"
    height="176"
    viewBox="0 0 177 176"
    fill="none"
  >
    <g filter="url(#filter0_f_960_3551)">
      <rect
        x="97.5342"
        y="42.6697"
        width="59.6553"
        height="47.2594"
        transform="rotate(47.1372 97.5342 42.6697)"
        fill="url(#paint0_linear_960_3551)"
      />
    </g>
    <g filter="url(#filter1_f_960_3551)">
      <rect
        x="136.079"
        y="109.716"
        width="54.2204"
        height="37.88"
        transform="rotate(149.777 136.079 109.716)"
        fill="url(#paint1_linear_960_3551)"
      />
    </g>
    <g filter="url(#filter2_f_960_3551)">
      <rect
        x="111.432"
        y="51.3744"
        width="78.5449"
        height="56.231"
        transform="rotate(103.279 111.432 51.3744)"
        fill="url(#paint2_linear_960_3551)"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_960_3551"
        x="24.747"
        y="4.52316"
        width="151.514"
        height="152.167"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="19.0733"
          result="effect1_foregroundBlur_960_3551"
        />
      </filter>
      <filter
        id="filter1_f_960_3551"
        x="32.0141"
        y="38.8381"
        width="142.211"
        height="136.317"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="19.0733"
          result="effect1_foregroundBlur_960_3551"
        />
      </filter>
      <filter
        id="filter2_f_960_3551"
        x="0.516567"
        y="0.312222"
        width="149.062"
        height="165.654"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="19.0733"
          result="effect1_foregroundBlur_960_3551"
        />
      </filter>
      <linearGradient
        id="paint0_linear_960_3551"
        x1="97.5342"
        y1="88.787"
        x2="143.799"
        y2="31.7987"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0085FF" />
        <stop
          offset="1"
          stop-color="#67DBFC"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_960_3551"
        x1="136.079"
        y1="146.68"
        x2="171.948"
        y2="96.5779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0085FF" />
        <stop
          offset="1"
          stop-color="#67DBFC"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_960_3551"
        x1="111.432"
        y1="106.246"
        x2="165.085"
        y2="33.1131"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0085FF" />
        <stop
          offset="1"
          stop-color="#67DBFC"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
